import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';

import { ClickMetric } from '../../admin/models/monitoring/click-monitoring.model';
import { environment } from '../../../../../environments/environment';

const EXPORT_EXCEL = `${environment.apiPrefix}/clicks-monitoring/export-excel`;
const GET_BY_DATE_RANGE = `${environment.apiPrefix}/clicks-monitoring/range-date`;
const getFilterByDateRangeUrl = (startDate, endDate) => `${GET_BY_DATE_RANGE}/start/${startDate}/end/${endDate}`;

@Injectable({
  providedIn: 'root',
})
export class ClicksMonitorService {
  constructor(private http: HttpClient) {}

  public exportExcel(startDate, endDate, lang): Observable<any> {
    return this.http.post(EXPORT_EXCEL, { startDate, endDate, lang }, { responseType: 'blob' });
  }

  public getByDateRange(startDate, endDate): Observable<ClickMetric[]> {
    return this.http.get<ClickMetric[]>(getFilterByDateRangeUrl(startDate, endDate));
  }
}
